import { createContext, useState, useEffect } from "react";
import { api } from "../config/api";
import toast from "../utils/toast";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Checks for existing session on page load/refresh
  useEffect(() => {
    const storedUser = localStorage.getItem("user") || sessionStorage.getItem("user");
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch {
        // Clear corrupted data
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("token");
      }
    }
    setLoading(false);
  }, []);

  const login = async (payload) => {
    try {
      const res = await api.post("/auth/login", payload);

      if (res.data.success) {
        // nextUser captures EVERYTHING the backend sends (username, role, and PERMISSIONS)
        const nextUser = {
          ...res.data.user,
          token: res.data.token,
        };

        const remember = Boolean(payload?.remember);
        const targetStorage = remember ? localStorage : sessionStorage;
        const otherStorage = remember ? sessionStorage : localStorage;

        // Clean up and set new session
        otherStorage.removeItem("token");
        otherStorage.removeItem("user");
        
        targetStorage.setItem("token", res.data.token);
        targetStorage.setItem("user", JSON.stringify(nextUser));
        
        setUser(nextUser); // Updates state for Sidebar access

        return { success: true, message: res.data.message };
      }

      return { success: false, message: res.data.message || "Login Failed" };
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Connection Error";
      return { success: false, message: errorMessage };
    }
  };

  const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("token");
    setUser(null);
    toast.success("Logged Out");
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
        loading,
      }}
    >
      {!loading && children}
    </AuthContext.Provider>
  );
};